module.exports = __webpack_public_path__ + "media/images/no_image-06b6f8be72d491a4cdf748f80e0fe89a.jpg";